﻿import React from 'react';
import {Grid} from "@mui/material";

type CardSubBodyContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used inside a BodyContainer to style with even more body
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardSubBodyContainer = ({ children, ...rest}: CardSubBodyContainerProps) => {
  return <Grid item xs={12} md={9} {...rest}>
    { children }
  </Grid>
}

export { CardSubBodyContainer };
